import React, { createContext, useState, useContext, useEffect } from "react";

import { safeLocalStorage } from '@/lib/browserStorage';
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    () => safeLocalStorage.getItem("drilllog-theme") || "system"
  );

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const resolved = theme === "system" ? mq.matches : theme === "dark";
      document.documentElement.classList.toggle("dark", resolved);
    };
    apply();
    if (theme === "system") {
      const handler = () => apply();
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
  }, [theme]);

  useEffect(() => {
    safeLocalStorage.setItem("drilllog-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);